import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { CreateBroadcast } from 'videoservice-openapi-react';
import { EBroadcastQueryKey, useBroadcastStore } from 'entities/broadcast';

export const useCreateBroadcast = () => {
  const createBroadcastMethod = useBroadcastStore(state => state.createBroadcast);
  const queryClient = useQueryClient();

  const createBroadcastMutation = useMutation({
    mutationKey: [EBroadcastQueryKey.CREATE_BROADCAST],
    mutationFn: (payload: CreateBroadcast) => createBroadcastMethod(payload),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [EBroadcastQueryKey.BROADCAST_FILTER]
      })
    },
  });

  const createBroadcast = useCallback((payload: CreateBroadcast) => createBroadcastMutation.mutate(payload), [createBroadcastMutation]);

  return {
    createBroadcast,
    createBroadcastMutation,
  };
};
